import { BASE_URL } from "../env";

const getStep = async (fieldIdArr) => {
  const stepService = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`;
  const fetchOptions = {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  if (typeof fieldIdArr === "object") {
    const fieldValueArr = await Promise.all(
      fieldIdArr.map((fieldId) =>
        fetch(`${stepService}/${fieldId}`, fetchOptions)
      )
    );

    const res = await Promise.all(fieldValueArr.map((res) => res.json()));
    return res.reduce((a, v) => ({ ...a, [v.fieldId]: v.fieldValue }), {});
  } else {
    const fieldId = fieldIdArr;
    const fieldValue = await fetch(`${stepService}/${fieldId}`, fetchOptions);
    return await fieldValue.json();
  }
};

export default getStep;
